import React from 'react'
import Navbar from './NavbarComponent';  

export default function NavbarManager({currentUser, history, setRoutesParams}) {
  
  return ( 
        <Navbar currentUser={currentUser} history={history} setRoutesParams={setRoutesParams} /> 
  )
} 
  